import React from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { X, Lock } from 'lucide-react';
import { getAccessLabel } from '../utils/accessLabels';
import { currentPagePath } from '../utils/redirect';

const AccessRequiredModal = ({ isOpen, onClose, accessLevel, action = 'listen', viewUrl, isAuthenticated }) => {
    const navigate = useNavigate();

    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) onClose();
    };

    const goTo = (path) => {
        onClose();
        navigate(path);
    };

    const label = getAccessLabel(accessLevel, action);

    const modalContent = (
        <div
            className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-y-auto"
            onClick={handleBackdropClick}
        >
            <div className="bg-gray-900 border border-purple-500/30 rounded-2xl p-8 max-w-sm w-full relative shadow-2xl text-center">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 p-2 text-gray-400 hover:text-white rounded-lg hover:bg-gray-700/50 transition-colors"
                >
                    <X className="w-5 h-5" />
                </button>

                <div className="w-16 h-16 bg-purple-500/20 rounded-full flex items-center justify-center mx-auto mb-5">
                    <Lock className="w-8 h-8 text-purple-400" />
                </div>

                <h2 className="text-xl font-bold text-white mb-2">{label}</h2>
                <p className="text-gray-400 text-sm mb-6 leading-relaxed">
                    This track is protected content. View its page for full details on how to unlock it.
                </p>

                <div className="flex flex-col gap-3">
                    {!isAuthenticated && (accessLevel === 'logged_in_required' || accessLevel === 'subscription_required') && (
                        <>
                            <button
                                onClick={() => goTo(`/login?redirect=${encodeURIComponent(currentPagePath())}`)}
                                className="w-full py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-semibold transition-colors"
                            >
                                Log In
                            </button>
                            <button
                                onClick={() => goTo(`/register?redirect=${encodeURIComponent(currentPagePath())}`)}
                                className="w-full py-3 bg-gray-700 hover:bg-gray-600 text-white rounded-lg font-medium transition-colors"
                            >
                                Join for Free
                            </button>
                        </>
                    )}
                    {isAuthenticated && accessLevel === 'subscription_required' && (
                        <button
                            onClick={() => goTo('/subscriptions')}
                            className="w-full py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-semibold transition-colors"
                        >
                            Become a Supporter
                        </button>
                    )}
                    {viewUrl && (
                        <button
                            onClick={() => goTo(viewUrl)}
                            className="w-full py-3 bg-gray-700 hover:bg-gray-600 text-white rounded-lg font-medium transition-colors"
                        >
                            View Track Page
                        </button>
                    )}
                </div>
            </div>
        </div>
    );

    return ReactDOM.createPortal(modalContent, document.body);
};

export default AccessRequiredModal;
